import { Box } from '@mui/material';

interface DashboardCanvasShellProps {
  children: React.ReactNode;
  canvasWidth: number;
  canvasHeight?: number;
}

/**
 * DashboardCanvasShell - Scroll container and fixed-width canvas wrapper
 */
export const DashboardCanvasShell: React.FC<DashboardCanvasShellProps> = ({ children, canvasWidth, canvasHeight }) => {
  return (
    <Box
      className="canvas-scroll-container"
      sx={{
        overflow: 'auto',
        flexGrow: 1,
        minHeight: 0,
        position: 'relative',
        bgcolor: 'background.editor',
      }}
    >
      <Box
        className="canvas-wrapper"
        sx={{
          width: `${canvasWidth}px`,
          height: canvasHeight ? `${canvasHeight}px` : 'auto',
          minHeight: '100%',
          position: 'relative',
          bgcolor: 'background.editor',
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
